import React from 'react';
import { IProps } from './types';
import { Formik, Form, Field, FormikProps, FieldArray, FormikHelpers } from 'formik';
import FieldAuto from 'components/FieldAuto';
import { InprocessSelectFormValue, InprocessSelectState } from 'constants/models/components/insureProcessFire/insureProcessSelect';
import commonService from 'utils/commonService';
import { YesNo, YesNoType } from 'constants/enums/yesNo.enum';
import { IBuildingInfoFormValue } from 'constants/models/components/insureProcessFire/buildingInfo';
import service from 'bff/services/fireProdService';
import _ from 'lodash';
import { FireGetFeeReq, FireGetFeeResItemContent, FirePlanContent, FirePlanItemBaseContent, FirePlanItemCoverageOptContent, FirePlanItemIndemnifyContent, FirePlanItemOptAmtContent, FirePlanItemOptBindingContent, FirePlanProdContent } from 'bff/models/product';
import { FireItemType } from 'constants/enums/fireItemType';
import InputWithRegex from 'components/InputWithRegex';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { Dispatch } from 'redux';
import { setRuleValidErrorModalVisible } from 'redux/actions/modal.action';
import { connect } from 'react-redux';
// import moment from 'moment';
import moment from 'moment-timezone';
import { CodeId } from 'constants/enums/codeId.enum';
import apiCommonService from 'bff/services/commonService';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import apiService from 'bff/services/apiService';
import { CodeClass } from 'constants/enums/codeClass.enum';

const initFormVal: InprocessSelectFormValue = {
  POLICY_ITEMS: new Array(0)
};

const initState: InprocessSelectState = {
  buildingInfoDetailsOpen: true,
  firePlans: new Array(0),
  activeProdId: '',
  activePlanId: '',
  activePlanName: '',
  showCalc: true,
  evalFireRes: {
    TOTAL_FEE: 0,
    ITEMS: new Array(0)
  },
  polvalCodes: new Array(0),
  hasMortgage: YesNoType.No,
  isDisable: false,
  firePropCodes: new Array(0),
  fireProductRestrict: []
};

let formInitialValues = initFormVal;

class InsureProcessSelect extends React.Component<IProps, InprocessSelectState> {
  private buildingInfoDetailsRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private productAreaRef: any = React.createRef();
  private formikRef = React.createRef() as React.RefObject<FormikProps<InprocessSelectFormValue>>;

  readonly state = initState;

  componentDidMount = async () => {
    commonService.scrollToTop();

    // 有暫存的資料、且有商品資料，為資料填寫頁返回來的
    if (
      this.props.tempSelect &&
      this.props.tempSelect.tempSelectFormValue &&
      this.props.tempSelect.tempSelectState &&
      this.props.tempSelect.tempSelectState.firePlans.length > 0
    ) {
      formInitialValues = {
        ...formInitialValues,
        ...this.props.tempSelect.tempSelectFormValue
      };

      this.setState({ ...this.props.tempSelect.tempSelectState });
      // console.log('firePlans', this.props.tempSelect.tempSelectState.firePlans);
      // console.log('policyItems', this.props.tempSelect.tempSelectFormValue.POLICY_ITEMS);
      return;
    }

    const { tempBuildingInfoFormValue } = this.props.tempBuildingInfo;

    // 取得 查詢商品可用方案資料 Request Model
    const firePlanListReq = this.handleGetFirePlansReq(tempBuildingInfoFormValue as IBuildingInfoFormValue);
    // 初始化頁面所需資料，取得 查詢商品可用方案資料 Request Model
    const initSetting = await service.fetchInitSelect(firePlanListReq);

    // 篩選選取的商品
    const policyPlan = this.handleFilterPolicyPlan(this.props.prodId, initSetting.firePlans);
    // console.log('firePlans', initSetting.firePlans)

    let isDisable = false;
    if (policyPlan) {
      isDisable = policyPlan.IS_DISABLE;
      if (policyPlan.DISABLE_MSG && policyPlan.DISABLE_MSG.length > 0) {
        this.props.setRuleValidErrorModalVisible(true, policyPlan.DISABLE_MSG);
      }
    }

    // 設定保障項目預設值
    let policyItems = new Array(0);
    if (policyPlan && policyPlan.ITEMS.length > 0) {
      policyItems = this.handleSetPolicyItemDefult(policyPlan.ITEMS);
    }

    // console.log('policyItems', policyItems);
    formInitialValues = {
      ...formInitialValues,
      POLICY_ITEMS: policyItems
    };

    this.handleFireProductRestrict();

    this.setState({
      firePlans: [...initSetting.firePlans],
      activeProdId: this.props.prodId,
      activePlanId: policyPlan?.PLAN_ID || '',
      activePlanName: policyPlan?.PLAN_NAME || '',
      showCalc: true,
      hasMortgage: policyPlan?.HAS_MORTGAGE || YesNoType.No,
      polvalCodes: [...initSetting.polValCodes],
      isDisable: isDisable,
      firePropCodes: [...initSetting.firePropCodes]
    });

    // console.log('temp State', JSON.stringify(this.props.tempState));
  }

  componentWillUnmount () {
    if (!this.formikRef || !this.formikRef.current) return;

    const formVal = this.formikRef.current.values;

    this.props.onUnmount(formVal, this.state);

    formInitialValues = {
      ...initFormVal
    };
  }

  /**
   * @description 取得 查詢商品可用方案資料 Request Model
  */
  handleGetFirePlansReq = (values: IBuildingInfoFormValue) => {
    const firePlanListReq = {
      DECORATION_COST: +values.DECORATION_COST >= 10000 ? +values.DECORATION_COST / 10000 : +values.DECORATION_COST,
      USAGE_AREA: parseFloat(Number.parseFloat(values.SQUARE_FEET).toFixed(2)),
      CITY_ID: values.CITY_ID,
      FLOOR: +values.CURRENT_FLOOR,
      TOTAL_FLOOR: +values.FLOOR_TOTAL,
      BUILDING_STRUCTURE: values.BUILDING_STRUCTURE,
      INSURED_DATE: moment(values.INSURED_DATE).format('YYYY/MM/DD')
    };

    return firePlanListReq;
  }

  /**
   * @description 取得 住火險限制
  */
  handleFireProductRestrict = async () => {
    const response = await apiCommonService.fetchSysOpts({ PCLASS: ['CONSTRAINT'] });
    if (!Array.isArray(response?.CONSTRAINT)) return null;
    this.setState({
      fireProductRestrict: await JSON.parse(response?.CONSTRAINT[0]?.PARAM_VALUE ?? '[]')
    });

    if (this.checkProdRestrict(this.state.activeProdId)) {
      const baseReq = commonService.getApiReqData();
      const reqConfig = commonService.getReqConfig();

      storageService.removeItem(storageKeys.InsurceProcessState);
      const response = await apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI);

      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '',
        html: response?.TRANRS?.CODES?.find((item:any) => item.CODE_ID === 'W074')?.CODE_VALUE ?? ''
      });
    }
  }

  /**
   * @description 篩選選取的商品
  */
  handleFilterPolicyPlan = (prodId: string, firePlans: FirePlanProdContent[]) => {
    const firePlan = _.find(firePlans, (firePlan: FirePlanProdContent) => firePlan.PROD_ID === prodId);

    if (!firePlan || !firePlan.PLANS || firePlan.PLANS.length === 0) return;

    return firePlan.PLANS[0];
  }

  /**
   * @description 設定保障項目預設值
   * @param items 保障項目
   * @param sugAmts 計算建議保額
  */
  handleSetPolicyItemDefult = (items: FirePlanItemBaseContent[]) => {
    return _.map(items, (item: FirePlanItemBaseContent) => {
      return {
        ...item,
        INDEMNIFYS: item.INDEMNIFYS && item.INDEMNIFYS.length > 0 ? _.map(item.INDEMNIFYS, (indemnify: FirePlanItemIndemnifyContent) => {
          return {
            ...indemnify,
            // ...this.handleSetChildDef(parentItem),
            INS_COVERAGE_OPTION: indemnify.INS_COVERAGE_OPTION && indemnify.INS_COVERAGE_OPTION.length > 0
              ? _.map(indemnify.INS_COVERAGE_OPTION, (coverageOpt: FirePlanItemCoverageOptContent) => {
                return {
                  ...this.handleSetChildDef(coverageOpt)
                };
              })
              : indemnify.INS_COVERAGE_OPTION,
            PREMIUM: ''
          };
        }) : [
          {
            PREMIUM: ''
          }
        ]
      };
    });
  }

  /**
   * @description 設定子項目預設值
  */
  handleSetChildDef = (coverageOpt: FirePlanItemCoverageOptContent) => {
    switch (coverageOpt.TYPE) {
      case FireItemType.TYPE_SHOW:
        return {
          ...coverageOpt,
          SHOW_VALUE: coverageOpt.VALUE
        };
      case FireItemType.TYPE_INPUT:
        return {
          ...coverageOpt,
          INPUT_VALUE: coverageOpt.LIMIT ? commonService.thousandFormat(`${coverageOpt.LIMIT}`) : ''
        };
      case FireItemType.TYPE_OPTION: {
        return {
          ...coverageOpt,
          SELECT_VALUE: coverageOpt.DEFAULT,
          SELECT_TEXT: _.find(coverageOpt.OPTIONS, (optChild: FirePlanItemOptAmtContent) => optChild.VALUE === coverageOpt.DEFAULT)?.TEXT
        };
      }
      case FireItemType.TYPE_TEXT: {
        return {
          ...coverageOpt,
          TEXT_VALUE: coverageOpt.VALUE
        };
      }
    }
  }

  /**
   * @description 開啟/關閉 建築物資料詳細資訊
   */
  handleBuildingInfoDetailsToggle = () => {
    this.setState(state => ({ ...state, buildingInfoDetailsOpen: !this.state.buildingInfoDetailsOpen }));
  }

  /**
   * 確認是否需要擋此商品
   * @param prodId
   */
  checkProdRestrict = (prodId: string) :boolean => {
    const insureDate = this.props.tempBuildingInfo.tempBuildingInfoFormValue?.INSURED_DATE;
    const checkProdId = this.state.fireProductRestrict.find(item => item.PROD_ID === prodId);
    if (!checkProdId) return false;
    if (checkProdId.CONS_SDATE && checkProdId.CONS_EDATE) {
      if (moment(checkProdId.CONS_SDATE).unix() > moment(checkProdId.CONS_EDATE).unix()) return false;
    }
    if (!checkProdId.CONS_SDATE && !checkProdId.CONS_EDATE) return false;
    if (checkProdId.CONS_SDATE) {
      if (moment(moment(insureDate).format('YYYY-MM-DD')).unix() < moment(checkProdId.CONS_SDATE).unix()) return false;
    }
    if (checkProdId.CONS_EDATE) {
      if (moment(moment(insureDate).format('YYYY-MM-DD')).unix() > moment(checkProdId.CONS_EDATE).unix()) return false;
    }
    if (this.props.tempBuildingInfo.tempBuildingInfoState?.renewalFire) {
      return checkProdId.RENEWAL !== 'Y';
    }
    return checkProdId.NEW !== 'Y';
  }

  /**
   * @description 選擇方案或商品按鈕 Click 事件
  */
  handleProdBtnClick = async (prodId: string, plans: FirePlanContent[]) => {
    if (this.checkProdRestrict(prodId)) {
      const baseReq = commonService.getApiReqData();
      const reqConfig = commonService.getReqConfig();

      storageService.removeItem(storageKeys.InsurceProcessState);
      const response = await apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI);

      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '',
        html: response?.TRANRS?.CODES?.find((item:any) => item.CODE_ID === 'W074')?.CODE_VALUE ?? ''
      });
    }

    if (!this.formikRef || !this.formikRef.current) return;

    commonService.setActiveProdId(this.props.insTypeId, prodId);

    const { tempBuildingInfoFormValue } = this.props.tempBuildingInfo;

    if (!tempBuildingInfoFormValue) return;

    // console.log('fireSugAmts', fireSugAmts);
    // console.log('plans', plans);

    let isDisable = false;
    if (plans[0]) {
      isDisable = plans[0].IS_DISABLE;
      if (plans[0].DISABLE_MSG && plans[0].DISABLE_MSG.length > 0) {
        this.props.setRuleValidErrorModalVisible(true, plans[0].DISABLE_MSG);
      }
    }

    let policyItems = new Array(0);
    let planId = '';
    let planName = '';
    let hasMortgage: string = YesNoType.No;
    if (plans[0] && plans[0].ITEMS.length > 0) {
      policyItems = this.handleSetPolicyItemDefult(plans[0].ITEMS);
      planId = plans[0].PLAN_ID;
      planName = plans[0].PLAN_NAME;
      hasMortgage = plans[0].HAS_MORTGAGE;
    }
    // console.log('policyItems', policyItems);
    const setFieldValue = this.formikRef.current.setFieldValue;
    setFieldValue('POLICY_ITEMS', policyItems);

    this.setState({
      activeProdId: prodId,
      activePlanId: planId,
      activePlanName: planName,
      hasMortgage: hasMortgage,
      showCalc: true,
      evalFireRes: {
        TOTAL_FEE: 0,
        ITEMS: new Array(0)
      },
      isDisable: isDisable
    });
  }

  /**
   * @description 建立保障內容區塊
   */
  handleGetPolicyItemContent = (policyItem: FirePlanItemBaseContent, policyItemIndex: number) => {
    const childCount = policyItem.INDEMNIFYS.length;

    const res = new Array(0);
    for (let i = 0; i < childCount; i += 1) {
      res.push(
        <tr key={i}>
          <td>
            {i === 0 && policyItem.ITEM_OPTIONAL === FireItemType.ITEM_CHECKBOX_SHOW ? (
              <div className="element__checkbox-group">
                <label htmlFor="house-fire-ins-1-checkbox">
                  <div className="element__checkbox">
                    <Field
                      type="checkbox"
                      name={`POLICY_ITEMS[${policyItemIndex}].CHECKED`}
                      id="house-fire-ins-1-checkbox"
                      onClick={() => {
                        this.setState({ showCalc: true });
                      }}
                    />
                    <div className="element__checkbox-btn" />
                  </div>
                  <span>{`${policyItem.ITEM_NAME}${policyItem.ITEM_DESC || ''}`}</span>
                </label>
              </div>
            )
              : i === 0 ? policyItem.ITEM_NAME : ''}
          </td>
          <td>
            {
              policyItem.INDEMNIFYS[i] && policyItem.INDEMNIFYS[i].INDEMNIFY_NAME_SHOW === '1' && `${policyItem.INDEMNIFYS[i].INDEMNIFY_NAME || ''} ${policyItem.INDEMNIFYS[i].INDEMNIFY_DESC || ''}`
            }
          </td>
          <td>
            {policyItem.INDEMNIFYS[i] && policyItem.INDEMNIFYS[i].INS_COVERAGE_SHOW === '1' && this.handleCreatePolicyItemInputElem(policyItem, policyItemIndex, i)}
          </td>
          <td>{commonService.thousandFormat(`${policyItem.INDEMNIFYS[i].PREMIUM}`)}</td>
        </tr>
      );
    }

    return res;
  }

  /**
 * @description 根據主附約建立保障內容區塊
 */
  handleCreatePolicyItemContent = (policyItems: FirePlanItemBaseContent[]) => {
    const mainItems: any = new Array(0);
    const subItems: any = [(
      <tr key="0" className="select-products__scheme-table-sub-title">
        <th>附約</th>
        <th />
        <th />
        <th />
      </tr>
    )];

    _.forEach(policyItems, (policyItem: FirePlanItemBaseContent, policyItemIndex: number) => {
      if (policyItem.ITEM_SHOW === '0') return;

      switch (policyItem.ITEM_TYPE) {
        case FireItemType.ITEM_TYPE_MAIN: {
          mainItems.push(this.handleGetPolicyItemContent(policyItem, policyItemIndex));
          break;
        }
        default: {
          subItems.push(this.handleGetPolicyItemContent(policyItem, policyItemIndex));
          break;
        }
      }
    });

    return (
      <>
        {mainItems}
        {subItems}
      </>
    );
  }

  /**
   * @description 建立保障項目 保險金額 欄位元素
  */
  handleCreatePolicyItemInputElem = (policyItem: FirePlanItemBaseContent, policyItemIndex: number, indemnifyIndex: number) => {
    const indemnify = policyItem.INDEMNIFYS[indemnifyIndex];

    if (!this.formikRef || !this.formikRef.current || !indemnify) return;
    const handleChange = this.formikRef.current.handleChange;
    const setFieldValue = this.formikRef.current.setFieldValue;
    const setFieldTouched = this.formikRef.current.setFieldTouched;

    if (!indemnify.INS_COVERAGE_OPTION || indemnify.INS_COVERAGE_OPTION.length === 0) return '';

    // const opt = _.filter(indemnify.INS_COVERAGE_OPTION, (opt: FirePlanItemCoverageOptContent) => opt.TYPE !== FireItemType.TYPE_TEXT);
    // if (!opt) return '-';
    // const optIndex = _.findIndex(indemnify.INS_COVERAGE_OPTION, (optContent: FirePlanItemCoverageOptContent) => optContent.TYPE === opt.TYPE);
    const res = new Array(0);

    _.forEach(indemnify.INS_COVERAGE_OPTION, (optContent: FirePlanItemCoverageOptContent, optIndex: number) => {
      switch (optContent.TYPE) {
        case FireItemType.TYPE_INPUT: {
          const maxLength = optContent.LIMIT ? commonService.thousandFormat(`${optContent.LIMIT}`).length : 9;
          const fieldName = `POLICY_ITEMS[${policyItemIndex}].INDEMNIFYS[${indemnifyIndex}].INS_COVERAGE_OPTION[${optIndex}]`;
          // ? `POLICY_ITEMS[${policyItemIndex}].INDEMNIFYS[${indemnifyIndex}].CHILDREN[${childItemIndex}].ITEM_OPTIONS[${optIndex}].INPUT_VALUE`
          // : `POLICY_ITEMS[${policyItemIndex}].INDEMNIFYS[${indemnifyIndex}].INS_COVERAGE_OPTION[${optIndex}].INPUT_VALUE`;
          res.push(
            <FieldAuto
              key={optIndex}
              component={InputWithRegex}
              autoWidth
              thousandFormat
              name={`${fieldName}.INPUT_VALUE`}
              className="element__input"
              autoComplete="off"
              maxLength={maxLength}
              onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                const val = e.currentTarget.value;
                let inVaild = false;
                if (val && optContent.LIMIT) {
                  let belowItemCheck = false;
                  // {#輸入保額} < 最低保額 10000
                  if (+commonService.removeComma(val) < 10000) {
                    inVaild = true;
                    sweetAlertService.modal({
                      icon: SweetAlertIcon.Info,
                      html: commonService.getCodeMsg(this.props.UICodes, CodeId.W061)
                    });
                  }
                  // {#輸入保額} > {#建議保額}
                  if (!inVaild && +commonService.removeComma(val) > +optContent.LIMIT) {
                    inVaild = true;
                    let msg = commonService.getCodeMsg(this.state.polvalCodes, CodeId.PV14);
                    msg = msg.replace('{#建議保額}', commonService.thousandFormat(`${optContent.LIMIT}`));
                    sweetAlertService.modal({
                      icon: SweetAlertIcon.Info,
                      html: msg
                    });
                  }

                  // {#輸入保額} < {#建議保額}
                  if (!inVaild && +commonService.removeComma(val) < (+optContent.LIMIT * 0.6)) {
                    inVaild = true;
                    belowItemCheck = true;
                    const msg = commonService.getCodeMsg(this.state.polvalCodes, CodeId.PV13);
                    sweetAlertService.modal({
                      icon: SweetAlertIcon.Info,
                      html: msg
                    });
                  }
                  if (belowItemCheck) {
                    apiCommonService.fetchSysTime().then((res: any) => {
                      this.setState({ belowItem_check_time: res });
                    });
                  }
                }
                setFieldTouched(`${fieldName}.INPUT_VALUE`, true);
              }}
              onChange={(val: string) => {
                this.setState({ showCalc: true });
                handleChange(`${fieldName}.INPUT_VALUE`)(val);
              }}
            />
          );
          break;
        }
        case FireItemType.TYPE_OPTION: {
          const fieldName = `POLICY_ITEMS[${policyItemIndex}].INDEMNIFYS[${indemnifyIndex}].INS_COVERAGE_OPTION[${optIndex}]`;
          // ? `POLICY_ITEMS[${policyItemIndex}].CHILDREN[${indemnifyIndex}].CHILDREN[${childItemIndex}].ITEM_OPTIONS[${optIndex}]`
          // : `POLICY_ITEMS[${policyItemIndex}].INDEMNIFYS[${indemnifyIndex}].INS_COVERAGE_OPTION[${optIndex}].SELECT_VALUE`;
          res.push(
            <Field
              as="select"
              key={optIndex}
              name={`${fieldName}.SELECT_VALUE`}
              className="element__select"
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                this.setState({ showCalc: true });
                setFieldValue(`${fieldName}.SELECT_TEXT`, e.currentTarget.selectedOptions.item(0)?.text);
                handleChange(`${fieldName}.SELECT_VALUE`)(e);
                // 判斷是否有關聯項目，進行設值
                if (optContent.OPTIONS && _.some(optContent.OPTIONS, (optContent: FirePlanItemOptAmtContent) => optContent.BINDING_LIMIT && optContent.BINDING_LIMIT.length > 0)) {
                  this.handleSetBindingLimit(e.currentTarget.value, optContent.OPTIONS, policyItem, policyItemIndex);
                }
              }}
            >
              <option value="">請選擇</option>
              {
                _.map(optContent.OPTIONS, (optContent: FirePlanItemOptAmtContent, index: number) => {
                  return <option key={index} value={optContent.VALUE}>{optContent.TEXT}</option>;
                })
              }
            </Field>
          );
          break;
        }
        case FireItemType.TYPE_SHOW: {
          res.push(commonService.thousandFormat(`${optContent.TEXT}`));
          break;
        }
        case FireItemType.TYPE_TEXT: {
          res.push(
            React.cloneElement(
              <>
                {
                  commonService.thousandFormat(`${optContent.TEXT}`)
                }
                {
                  optContent.VALUE && (
                    <>
                      <br />
                      {
                        commonService.thousandFormat(`${optContent.TEXT_VALUE}`)
                      }
                    </>
                  )
                }
              </>, { key: optIndex })
          );
          break;
        }
        default:
          return 'OutException';
      }
    });

    return res;
  }

  /**
   * @description 設定連動項目內容值
   */
  handleSetBindingLimit = (val: any, opts: FirePlanItemOptAmtContent[], policyItem: FirePlanItemBaseContent, policyItemIndex: number) => {
    // 取得下拉值對應的 opt
    const opt = _.find(opts, (opt: FirePlanItemOptAmtContent) => +opt.VALUE === +val);
    if (!opt || !opt.BINDING_LIMIT || opt.BINDING_LIMIT.length === 0) return;

    // 巡覽 opt 的綁定限制條件
    _.forEach(opt.BINDING_LIMIT, (limit: FirePlanItemOptBindingContent) => {
      // 取得保障項目內與限制項目 INDEMNIFY_ID 相符者 index
      const indemnifyIndex = _.findIndex(policyItem.INDEMNIFYS, (indemnify: FirePlanItemIndemnifyContent) => indemnify.INDEMNIFY_ID === limit.INDEMNIFY_ID);
      if (indemnifyIndex === -1) return;

      // 取得限制項目
      const indemnify = policyItem.INDEMNIFYS[indemnifyIndex];
      if (!indemnify.INS_COVERAGE_OPTION || indemnify.INS_COVERAGE_OPTION.length === 0) return;

      // 取得對應的限制項目 OPTION 內容
      const opt = _.find(indemnify.INS_COVERAGE_OPTION, (opt: FirePlanItemCoverageOptContent) => opt.TYPE !== FireItemType.TYPE_TEXT);
      if (!opt) return;

      const optIndex = _.findIndex(indemnify.INS_COVERAGE_OPTION, (optContent: FirePlanItemCoverageOptContent) => optContent.TYPE === opt.TYPE);
      if (optIndex === -1) return;

      if (!this.formikRef || !this.formikRef.current) return;
      const setFieldValue = this.formikRef.current.setFieldValue;

      const fieldName = `POLICY_ITEMS[${policyItemIndex}].INDEMNIFYS[${indemnifyIndex}].INS_COVERAGE_OPTION[${optIndex}]`;

      switch (indemnify.INS_COVERAGE_OPTION[optIndex].TYPE) {
        case FireItemType.TYPE_SHOW:
          setFieldValue(`${fieldName}.TEXT`, limit.TEXT);
          setFieldValue(`${fieldName}.SHOW_VALUE`, limit.VALUE);
          break;
      }
    });
  }

  /**
   * @description 返回上一頁事件
  */
  handleGoBack = () => {
    const formVal: InprocessSelectFormValue = {
      ...initFormVal
    };

    const activeProdId = this.state.activeProdId;

    this.setState({ ...initState });

    this.props.onGoBack(formVal, initState, activeProdId);
  }

  /**
   * @description 表單 Submit 事件
  */
  handleFormSubmit = async (values: InprocessSelectFormValue, actions: FormikHelpers<InprocessSelectFormValue>) => {
    if (!this.state.activeProdId && !this.state.activePlanId && !this.state.activePlanName) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '請先選擇方案或商品'
      });
      return;
    }

    if (this.state.showCalc) {
      await this.handleCalc(values);
      return;
    }

    this.props.onSubmit(values, this.state);
  }

  /**
   * @description 進行保障項目檢核、試算
  */
  handleCalc = async (values: InprocessSelectFormValue) => {
    const { tempBuildingInfoFormValue } = this.props.tempBuildingInfo;
    if (!tempBuildingInfoFormValue) return;

    // console.log('values', values.POLICY_ITEMS);
    // 檢核是否有未輸入 保險金額 項目
    const hasEmptyAmt = this.handleValidEmptyAmt(values.POLICY_ITEMS);
    if (hasEmptyAmt) return;

    // 檢核是否有輸入超過建議 保險金額 項目
    const hasExceedAmt = this.handleValidLimitAmt(values.POLICY_ITEMS);
    if (hasExceedAmt) return;

    // 2.車險保費計算API
    const evalRes = await this.handleGetFee(values.POLICY_ITEMS, tempBuildingInfoFormValue);
    if (!evalRes) return;

    // 更新原始保費、優惠保費欄位
    this.handleUpdatePolicyPrenium(values, evalRes.ITEMS);

    this.setState({
      showCalc: false,
      evalFireRes: evalRes
    });

    this.props.onCalc(values, this.state);
  }

  /**
   * @description 檢核是否有未輸入 保險金額 項目
  */
  handleValidEmptyAmt = (policyItems: FirePlanItemBaseContent[]) => {
    // 檢核有無未選取投保金額的項目
    const noValItems = new Array(0);

    _.forEach(policyItems, (policyItem: FirePlanItemBaseContent) => {
      _.forEach(policyItem.INDEMNIFYS, (indemnify: FirePlanItemIndemnifyContent) => {
        if (indemnify.INS_COVERAGE_OPTION && indemnify.INS_COVERAGE_OPTION.length > 0) {
          _.forEach(indemnify.INS_COVERAGE_OPTION, (opt: FirePlanItemCoverageOptContent) => {
            switch (opt.TYPE) {
              case FireItemType.TYPE_INPUT:
                if ((!opt.INPUT_VALUE || +commonService.removeComma(opt.INPUT_VALUE) === 0) && noValItems.indexOf(policyItem.ITEM_NAME) === -1) {
                  noValItems.push(indemnify.INDEMNIFY_NAME);
                }
                break;
              case FireItemType.TYPE_OPTION:
                if (opt.SELECT_VALUE === '' && noValItems.indexOf(indemnify.INDEMNIFY_NAME) === -1) {
                  noValItems.push(policyItem.ITEM_NAME);
                }
                break;
            }
          });
        }
      });
    });

    if (noValItems.length > 0) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: `商品<br />${noValItems}<br />保險金額有未填寫項目，請確認`
      }).then(() => {
        setTimeout(() => {
          // 滑動到保障項目頂端
          window.scroll({
            top: this.productAreaRef.current.offsetTop + 100
          });
        }, 100);
      });
    }

    return noValItems.length > 0;
  }

  /**
   * @description 檢核是否有輸入超過建議 保險金額 項目
  */
  handleValidLimitAmt = (policyItems: FirePlanItemBaseContent[]) => {
    // 超出建議額項目
    const exceedItems = new Array(0);
    // 低於最低保額 1 W 的項目
    const underMinItems = new Array(0);
    // const belowItems = new Array(0);

    _.forEach(policyItems, (policyItem: FirePlanItemBaseContent) => {
      _.forEach(policyItem.INDEMNIFYS, (indemnify: FirePlanItemIndemnifyContent) => {
        if (indemnify.INS_COVERAGE_OPTION && indemnify.INS_COVERAGE_OPTION.length > 0) {
          _.forEach(indemnify.INS_COVERAGE_OPTION, (opt: FirePlanItemCoverageOptContent) => {
            if (opt.TYPE === FireItemType.TYPE_INPUT && opt.INPUT_VALUE && opt.LIMIT) {
              if (+commonService.removeComma(opt.INPUT_VALUE) < 10000) {
                underMinItems.push(policyItem.ITEM_NAME);
              }

              // {#輸入保額} > {#建議保額}
              if (+commonService.removeComma(opt.INPUT_VALUE) > +opt.LIMIT && exceedItems.indexOf(`${policyItem.ITEM_NAME}-${commonService.thousandFormat(`${opt.LIMIT}`)}`) === -1) {
                exceedItems.push(`${policyItem.ITEM_NAME}-${commonService.thousandFormat(`${opt.LIMIT}`)}`);
              }

              // // {#輸入保額} < {#建議保額}
              // if (+commonService.removeComma(opt.INPUT_VALUE) < +opt.LIMIT && belowItems.indexOf(`${policyItem.ITEM_NAME}`) === -1) {
              //   belowItems.push(`${policyItem.ITEM_NAME}`);
              // }
            }
          });
        }
      });
    });

    const errorMsgs = new Array(0);
    const exceedMsg = commonService.getCodeMsg(this.state.polvalCodes, CodeId.PV14);
    // const belowMsg = commonService.getCodeMsg(this.state.polvalCodes, CodeId.PV13);
    const underMinMsg = commonService.getCodeMsg(this.props.UICodes, CodeId.W061);
    _.forEach(underMinItems, (underMinItem: string) => {
      errorMsgs.push(underMinMsg);
    });

    _.forEach(exceedItems, (exceedItem: string) => {
      const strArray = exceedItem.split('-');

      const msg = exceedMsg.replace('{#建議保額}', strArray[1]);

      errorMsgs.push(msg);
    });

    // _.forEach(belowItems, (belowItem: string) => {
    //   errorMsgs.push(belowMsg);
    // });

    if (errorMsgs.length > 0) {
      this.props.setRuleValidErrorModalVisible(true, errorMsgs);
    }

    return errorMsgs.length > 0;
  }

  /**
   * @description 進行保費試算
  */
  handleGetFee = async (policyItems: FirePlanItemBaseContent[], buildingInfoFormVal: IBuildingInfoFormValue) => {
    const itemsReq = new Array(0);
    _.forEach(policyItems, (policyItem: FirePlanItemBaseContent) => {
      if (policyItem.ITEM_OPTIONAL === FireItemType.ITEM_CHECKBOX_SHOW && !policyItem.CHECKED) return;
      _.forEach(policyItem.INDEMNIFYS, (indemnify: FirePlanItemIndemnifyContent) => {
        const item: any = {
          ITEM_ID: policyItem.ITEM_ID,
          INDEMNIFY_ID: indemnify.INDEMNIFY_ID,
          LIMIT: null,
          VALUE: null,
          TYPE: null
        };

        if (indemnify.INS_COVERAGE_OPTION && indemnify.INS_COVERAGE_OPTION.length > 0) {
          _.forEach(indemnify.INS_COVERAGE_OPTION, (opt: FirePlanItemCoverageOptContent) => {
            item.TYPE = opt.TYPE;

            switch (opt.TYPE) {
              case FireItemType.TYPE_INPUT:
                item.LIMIT = +opt.LIMIT;
                item.VALUE = +commonService.removeComma(opt.INPUT_VALUE);
                break;
              case FireItemType.TYPE_OPTION:
                item.VALUE = +opt.SELECT_VALUE;
                break;
              case FireItemType.TYPE_SHOW:
                item.VALUE = +commonService.removeComma(`${opt.SHOW_VALUE}`);
                break;
            }
          });
        }

        itemsReq.push(item);
      });
    });

    const calcReq: FireGetFeeReq = {
      INS_TYPE_ID: this.props.insTypeId,
      PROD_ID: this.state.activeProdId,
      PLAN_ID: this.state.activePlanId,
      START_DATE: moment(buildingInfoFormVal.INSURED_DATE).format('YYYY/MM/DD'),
      END_DATE: moment(buildingInfoFormVal.INSURED_DATE).add(1, 'y').format('YYYY/MM/DD'),
      BUILDING: {
        POSTCODE: buildingInfoFormVal.POST_CODE,
        CITY_ID: buildingInfoFormVal.CITY_ID,
        AREA_ID: buildingInfoFormVal.AREA_ID,
        ADDRESS_RD_ST: buildingInfoFormVal.STREET_ID_NAME,
        ADDRESS_LN: buildingInfoFormVal.ADDRESS_ROADWAY ? +buildingInfoFormVal.ADDRESS_ROADWAY : undefined,
        ADDRESS_ALY: buildingInfoFormVal.ADDRESS_ALLEY ? +buildingInfoFormVal.ADDRESS_ALLEY : undefined,
        ADDRESS_NO: buildingInfoFormVal.ADDRESS_NUMBER_OF
          ? `${buildingInfoFormVal.ADDRESS_NUMBER}-${buildingInfoFormVal.ADDRESS_NUMBER_OF}`
          : buildingInfoFormVal.ADDRESS_NUMBER,
        ADDRESS_F: buildingInfoFormVal.ADDRESS_FLOOR && buildingInfoFormVal.ADDRESS_FLOOR_OF
          ? `${buildingInfoFormVal.ADDRESS_FLOOR}-${buildingInfoFormVal.ADDRESS_FLOOR_OF}`
          : buildingInfoFormVal.ADDRESS_FLOOR
            ? buildingInfoFormVal.ADDRESS_FLOOR
            : undefined,
        BUILDING_FLOOR: +buildingInfoFormVal.FLOOR_TOTAL,
        BUILDING_BASEMENT: +buildingInfoFormVal.BASEMENT_FLOOR_TOTAL,
        USAGE_AREA: parseFloat(Number.parseFloat(buildingInfoFormVal.SQUARE_FEET).toFixed(2)),
        BUILDING_STRUCTURE: buildingInfoFormVal.BUILDING_STRUCTURE,
        ROOF_STRUCTURE: buildingInfoFormVal.ROOF_TYPE,
        BUILDING_YEAR: buildingInfoFormVal.CONSTRUCTION_YEAR,
        COMMERCIAL_BUILDING: buildingInfoFormVal.TRADE === YesNo.Yes ? '1' : '0',
        DECORATION_COST: +buildingInfoFormVal.DECORATION_COST >= 10000 ? +buildingInfoFormVal.DECORATION_COST / 10000 : +buildingInfoFormVal.DECORATION_COST
      },
      ITEMS: itemsReq
    };

    // console.log('calcReq', JSON.stringify(calcReq));
    return await service.getFee(calcReq);
  }

  /**
  * @description 更新 保險費 欄位
 */
  handleUpdatePolicyPrenium = (values: InprocessSelectFormValue, feeResArray: FireGetFeeResItemContent[]) => {
    if (!this.formikRef || !this.formikRef.current) return;

    let policyItems: any = [...values.POLICY_ITEMS];

    // 復原所有保費項目金額
    policyItems = _.map(policyItems, (policyItem: FirePlanItemBaseContent) => {
      return {
        ...policyItem,
        INDEMNIFYS: _.map(policyItem.INDEMNIFYS, (indemnify: FirePlanItemIndemnifyContent) => {
          return {
            ...indemnify,
            PREMIUM: ''
          };
        })
      };
    });

    // 紀錄連結項目 ID
    // const bindItemIds = new Array(0);

    policyItems = _.map(policyItems, (policyItem: FirePlanItemBaseContent) => {
      const newFeeResArray = _.filter(feeResArray, (feeRes: FireGetFeeResItemContent) => feeRes.ITEM_ID === policyItem.ITEM_ID);
      if (!newFeeResArray || newFeeResArray.length === 0) return policyItem;

      if (policyItem.INDEMNIFYS && policyItem.INDEMNIFYS.length > 0) {
        return {
          ...policyItem,
          INDEMNIFYS: _.map(policyItem.INDEMNIFYS, (indemnify: FirePlanItemIndemnifyContent) => {
            // // 紀錄連結項目
            // indemnify.INS_COVERAGE_OPTION && _.forEach(indemnify.INS_COVERAGE_OPTION, (coverageOpt: FirePlanItemCoverageOptContent) => {
            //   coverageOpt.OPTIONS && _.forEach(coverageOpt.OPTIONS, (opt: FirePlanItemOptAmtContent) => {
            //     if (opt.BINDING_LIMIT && opt.BINDING_LIMIT.length > 0) {
            //       _.forEach(opt.BINDING_LIMIT, (bindLimt: FirePlanItemOptBindingContent) => {
            //         if (bindItemIds.indexOf(bindLimt.INDEMNIFY_ID) === -1) {
            //           bindItemIds.push(bindLimt.INDEMNIFY_ID);
            //         }
            //       })
            //     }
            //   })
            // });

            const feeRes = _.find(newFeeResArray, (feeRes: FireGetFeeResItemContent) => feeRes.INDEMNIFY_ID === indemnify.INDEMNIFY_ID);

            // // 無對應的保費試算金額，且有連結項目，且當前 indemnify.INDEMNIFY_ID 存在於連結項目內，保費欄位更新為空白，不顯示 - 號
            // if (!feeRes && bindItemIds.length > 0 && bindItemIds.indexOf(indemnify.INDEMNIFY_ID) !== -1) {
            //   return {
            //     ...indemnify,
            //     PREMIUM: ''
            //   }
            // }

            if (!feeRes) return indemnify;

            return {
              ...indemnify,
              PREMIUM: `${feeRes.FEE}`
            };
          })
        };
      }

      return policyItem;
    });

    this.formikRef.current.setFieldValue('POLICY_ITEMS', policyItems);
  }

  render () {
    const { tempBuildingInfoFormValue } = this.props.tempBuildingInfo;
    const buildingInfoDetailsElemHeight = (this.state.buildingInfoDetailsOpen && this.buildingInfoDetailsRef && this.buildingInfoDetailsRef.current) ? this.buildingInfoDetailsRef.current.clientHeight : 0;

    // #region 建築物資料區塊相關方法

    /**
     * @description 取得完整 標的物地址
    */
    const handleGetFullAddress = (values: IBuildingInfoFormValue) => {
      return commonService.getFullAddress(
        values.POST_CODE, values.CITY_NAME, values.AREA_NAME, values.STREET_ID_NAME, values.ADDRESS_ROADWAY,
        values.ADDRESS_ALLEY, values.ADDRESS_NUMBER, values.ADDRESS_NUMBER_OF, values.ADDRESS_FLOOR, values.ADDRESS_FLOOR_OF,
        values.ADDRESS_REMARK
      );
    };

    // #endregion

    // #region 建立可選擇方案或商品按鈕

    let prodBtns: any;
    if (this.state.firePlans.length > 0) {
      prodBtns = _.map(this.state.firePlans, (plan: FirePlanProdContent, index: number) => {
        const classNames = ['select-products__scheme-list-item-btn'];
        if (plan.PROD_ID === this.state.activeProdId) {
          classNames.push('select-products__scheme-list-item-btn--active');
        }

        return (
          <button
            key={index}
            type="button"
            className={classNames.join(' ')}
            onClick={() => this.handleProdBtnClick(plan.PROD_ID, plan.PLANS)}
          >
            {plan.PROD_NAME}
          </button>
        );
      });
    }

    // #endregion
    return (
      <div className="insure-process-select">
        <Formik
          initialValues={formInitialValues}
          onSubmit={this.handleFormSubmit}
          innerRef={this.formikRef as any}
          enableReinitialize
        >
          {({ values }) => (
            <Form>
              <div className="insure-process-select__content">
                {/* 建築物資料 */}
                <div className="building-info">
                  {
                    tempBuildingInfoFormValue && (
                      <>
                        <div className="building-info__title">
                          <span>建築物資料</span>
                          <button
                            type="button"
                            className={'element__icon-button' + (this.state.buildingInfoDetailsOpen ? ' element__icon-button--close' : ' element__icon-button--add')}
                            onClick={this.handleBuildingInfoDetailsToggle}
                          >
                            {this.state.buildingInfoDetailsOpen ? '關閉詳細資訊' : '開啟詳細資訊'}
                          </button>
                        </div>
                        <div className="building-info__content">
                          <div className="building-info__details" style={{ height: buildingInfoDetailsElemHeight }}>
                            <div className="building-info__list" ref={this.buildingInfoDetailsRef}>
                              <div className="building-info__list-container">
                                <div className="element__list-group">
                                  <div className="element__list-group-title">標的物地址</div>
                                  <div className="element__list-group-content">{handleGetFullAddress(tempBuildingInfoFormValue)}</div>
                                </div>
                                <div className="element__list-group">
                                  <div className="element__list-group-title">總樓層數</div>
                                  <div className="element__list-group-content">
                                    {`地上層共${tempBuildingInfoFormValue.FLOOR_TOTAL}層 地下層共${tempBuildingInfoFormValue.BASEMENT_FLOOR_TOTAL}層；所在樓層第${tempBuildingInfoFormValue.CURRENT_FLOOR}層`}
                                  </div>
                                </div>
                                <div className="element__list-group">
                                  <div className="element__list-group-title">使用面積(含公設)</div>
                                  <div className="element__list-group-content">
                                    {`${+tempBuildingInfoFormValue.SQUARE_FEET}坪`}
                                  </div>
                                </div>
                                <div className="element__list-group">
                                  <div className="element__list-group-title">建築物結構</div>
                                  <div className="element__list-group-content">
                                    {tempBuildingInfoFormValue.BUILDING_STRUCTURE_NAME}
                                  </div>
                                </div>
                                <div className="element__list-group">
                                  <div className="element__list-group-title">屋頂別</div>
                                  <div className="element__list-group-content">
                                    {tempBuildingInfoFormValue.ROOF_TYPE_NAME}
                                  </div>
                                </div>
                                <div className="element__list-group">
                                  <div className="element__list-group-title">建造年份</div>
                                  <div className="element__list-group-content">
                                    {`民國${+tempBuildingInfoFormValue.CONSTRUCTION_YEAR}年`}
                                  </div>
                                </div>
                                <div className="element__list-group">
                                  <div className="element__list-group-title">同棟樓是否有營業</div>
                                  <div className="element__list-group-content">
                                    {
                                      tempBuildingInfoFormValue.TRADE === YesNo.Yes ? '是' : '否'
                                    }
                                  </div>
                                </div>
                                <div className="element__list-group">
                                  <div className="element__list-group-title">裝潢費用</div>
                                  <div className="element__list-group-content">
                                    {`${tempBuildingInfoFormValue.DECORATION_COST_NAME}`}/坪
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )
                  }
                </div>
                {/* 選擇方案或商品 */}
                <div className="select-products">
                  <div className="select-products__title">選擇方案或商品</div>
                  <div className="select-products__content">
                    <div className="select-products__scheme-list">
                      {prodBtns}
                    </div>
                    <table className="select-products__scheme-table" ref={this.productAreaRef}>
                      <tbody>
                        <tr className="select-products__scheme-table-title">
                          <th>商品</th>
                          <th>保障內容</th>
                          <th>保險金額</th>
                          <th>保險費</th>
                        </tr>
                        <FieldArray name="POLICY_ITEMS">
                          {
                            () => (
                              <>
                                {
                                  values.POLICY_ITEMS.length > 0 && this.handleCreatePolicyItemContent(values.POLICY_ITEMS)
                                }
                              </>
                            )
                          }
                        </FieldArray>
                        <tr>
                          <td />
                          <td />
                          <td />
                          <td>{`NT$ ${commonService.thousandFormat(`${this.state.evalFireRes.TOTAL_FEE}`)} 元`}</td>
                        </tr>
                      </tbody>
                    </table>
                    <p className="select-products__remind">{commonService.htmlParser(commonService.getCodeMsg(this.state.firePropCodes, CodeId.FIREPROPRM01))}</p>
                  </div>
                </div>
              </div>
              <div className="insure-process-select__controls">
                <button type="button" className="element__button element__button--red-border" onClick={this.handleGoBack}>返回上一頁</button>
                <button type="submit" disabled={this.state.isDisable || this.checkProdRestrict(this.state.activeProdId)} className="element__button element__button--red">
                  {this.state.showCalc ? '試算' : '下一步'}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

const mapDisatchToProps = (dispatch: Dispatch) => {
  return {
    setRuleValidErrorModalVisible: (visible: boolean, errorMsgs: any[]) => dispatch(setRuleValidErrorModalVisible(visible, errorMsgs))
  };
};

export default connect(null, mapDisatchToProps)(InsureProcessSelect);
